export default __webpack_public_path__ + "static/media/eth_xs.e220007f.svg";